import './quiz';

/* ============================================================
   Лендінг «Адвокат у вашому місті» (partner/lawyers)
   WP-тема: підключається через functions.php (theme_assets()),
   конфіг (window.LEAD_CONFIG) друкується туди ж з PHP-фільтрів.

   Реалізує обидва варіанти з ТЗ в одному файлі:

   ВАРІАНТ 1 — динамічна вставка ключового запиту в заголовок.
     ?utm_term={keyword} → заголовок сторінки = ключовий запит,
     «напрямок питання» ліда = цей самий запит, поле питання у формі
     не показується. Якщо параметр не передався (або в ньому лишився
     нерозгорнутий макрос {keyword}) — показується заголовок за
     замовчуванням із розмітки.

   ВАРІАНТ 2 — вибір/опис напрямку у формі.
     Немає ключового запиту → у формі з’являється поле
     «Ваше питання (коротко опишіть)», воно і стає «напрямком
     питання» ліда. Плюс картки напрямків права: клік по картці
     підставляє напрямок у форму.

   Керується через window.LEAD_CONFIG (див. <head> index.html і README.md).
   ============================================================ */
(function () {
  'use strict';

  var CFG = Object.assign({
    endpoint: '',
    partner: 'lawyers',
    phone: '+380733753317',
    keywordParam: 'utm_term',
    mode: 'auto',
    keywordMaxLength: 90,
    /* демо-панель перемикання варіантів: true — показати (тільки для показу
       макета), false — сторінка віддається як є, без перемикача */
    demoSwitch: false,
    /* власні назви, яких немає у вбудованому словнику міст:
       прізвища адвокатів, назви районів, бренди */
    properNouns: [],
    /* true — після валідації форма йде звичайним POST на свій action
       (як на consultant.net.ua/partner/lawyers); false — JSON на endpoint */
    nativeSubmit: false
  }, window.LEAD_CONFIG || {});

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'loc_id'];
  var STORE_KEY = 'clm_lawyers_utm';

  /* ============================================================
     1. UTM-мітки: читаємо з URL, запам’ятовуємо на час сесії
     ============================================================ */
  function readUtm() {
    var q = new URLSearchParams(location.search);
    var fromUrl = {}, has = false;
    UTM_KEYS.forEach(function (k) {
      var v = q.get(k);
      if (v !== null && v !== '') { fromUrl[k] = v; has = true; }
    });
    if (has) {
      try { localStorage.setItem(STORE_KEY, JSON.stringify(fromUrl)); } catch (e) {}
      return fromUrl;
    }
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}'); } catch (e) { return {}; }
  }

  /* Ключове слово приходить із URL — тобто це недовірені дані.
     Тому: тільки текст, без HTML, з обмеженням довжини. */
  function cleanKeyword(raw) {
    if (!raw) return '';
    var v = String(raw).replace(/\+/g, ' ');
    try { v = decodeURIComponent(v); } catch (e) {}
    v = v.replace(/[<>]/g, ' ')                        // жодного HTML
         .replace(/[\u0000-\u001F\u007F]/g, ' ')       // керуючі символи
         .replace(/\s+/g, ' ')
         .trim();
    if (!v) return '';
    if (/[{}]/.test(v)) return '';                     // макрос {keyword} не розгорнувся
    if (/^https?:\/\//i.test(v)) return '';            // у заголовок не ставимо посилання
    if (v.length > CFG.keywordMaxLength) return '';
    if (!/[a-zA-Zа-яА-ЯіїєґІЇЄҐ]/.test(v)) return '';  // самі цифри/символи — не заголовок
    return v;
  }


  /* ============================================================
     1a. Регістр ключового запиту.
         Ключ приходить із оголошення в довільному регістрі
         («військовий адвокат бориспіль», «АДВОКАТ ТЦК»), а в заголовку
         має читатися як звичайна фраза: власні назви — з великої,
         решта слів — з малої, абревіатури лишаються великими.
         → «Військовий адвокат Бориспіль», «Адвокат ТЦК».
         Правило діє тільки на цьому лендінгу.
     ============================================================ */

  /* Корені власних назв: збіг за початком слова + відмінкове закінчення
     зі списку PN_TAILS. Два корені там, де при відмінюванні змінюється
     голосна: Львів → Львова, Бориспіль → Борисполі, Київ → Києві. */
  var PN_STEMS = (
    'київ києв харків харков одес дніпро дніпр донецьк запоріжж львів львов ' +
    'миколаїв миколаєв маріупол луганськ вінниц макіївк севастопол сімферопол ' +
    'херсон полтав чернігів чернігов черкас житомир хмельницьк чернівц горлівк ' +
    'кропивницьк івано-франківськ кременчук тернопіль тернопол луцьк краматорськ ' +
    'мелітопол керч нікопол бердянськ слов\'янськ словянськ ужгород павлоград ' +
    'сєвєродонецьк кам\'янське камянське олександрі конотоп умань уман бровар ' +
    'бориспіль бориспол ірпінь ірпен буч вишнев васильків васильков обухів обухов ' +
    'фастів фастов вишгород переяслав славутич яготин богуслав кагарлик тараща ' +
    'українк боярк березань узин сквир макарів макаров бердичів бердичов ' +
    'коростень коростен новоград-волинський шепетівк славут нетішин ' +
    'старокостянтинів старокостянтинов ніжин прилук шостк охтирк лубн миргород ' +
    'лозов ізюм куп\'янськ купянськ чугуїв чугуєв балаклі первомайськ вознесенськ ' +
    'южноукраїнськ каховк генічеськ скадовськ токмак енергодар бахмут дружківк ' +
    'костянтинівк покровськ мирноград лисичанськ рубіжн старобільськ дрогобич ' +
    'червоноград самбір самбор трускавець трускавц мукачев хуст калуш коломи ' +
    'нововолинськ ковел володимир кам\'янець-подільський камянець-подільський ' +
    'світловодськ знам\'янк знамянк жмеринк могилів-подільський гайсин хмільник ' +
    'козятин ізмаїл білгород-дністровський чорноморськ болград україн'
  ).split(' ');

  /* Назви, форма яких збігається зі звичайним словом («суми» — і місто, і
     «сума боргу»; «рівне» — і місто, і «рівне ставлення»). Такі слова
     вважаємо містом лише в кінці фрази: в оголошеннях місто стоїть
     останнім («адвокат суми»), а в реченні — усередині («стягнення суми
     боргу»). */
  var PN_EXACT_LAST = ('суми сумах сумами рівне рівного рівному покров покрова ' +
                       'стрий стрия стрию дубно южне марганець марганцю сарни').split(' ');

  /* Складені назви з двох слів */
  var PN_PHRASES = ['кривий ріг', 'біла церква', 'нова каховка', 'жовті води',
                    'горішні плавні', 'мала виска', 'нові санжари'];

  /* Відмінкові закінчення іменників. Прикметникових (-ський, -ська) тут
     немає навмисно: «київський» — не власна назва й лишається з малої. */
  var PN_TAILS = ['', 'а', 'я', 'у', 'ю', 'і', 'ї', 'е', 'є', 'и', 'ь',
                  'ом', 'ем', 'єм', 'ою', 'ею', 'ів', 'ам', 'ах', 'ові', 'еві', 'єві'];

  /* Прізвищеві суфікси: у цьому контексті однозначні. */
  var PN_SURNAME = ['енко', 'енка', 'енку', 'енком', 'енків', 'ченко', 'чук', 'чука',
                    'чуку', 'чуком', 'юк', 'юка', 'юку', 'юком', 'ишин', 'ишина'];

  /* Абревіатури, поширені в цій тематиці, — завжди великими. */
  var PN_ABBR = ('дтп тцк сзч влк мсек зсу пдр єспл дбр сбу набу мвс тов фоп ' +
                 'осбб жек бті цпк кпк кас купап дпс дфс').split(' ');

  function pnNorm(w) {
    return w.toLowerCase().replace(/[’ʼ`´]/g, "'");
  }

  function pnUpFirst(w) {
    return w.charAt(0).toUpperCase() + w.slice(1);
  }

  function pnExtra() {
    var list = CFG.properNouns;
    return Object.prototype.toString.call(list) === '[object Array]'
      ? list.map(function (x) { return pnNorm(String(x)); }) : [];
  }

  function pnIsProper(word, isLast) {
    var w = pnNorm(word).replace(/^[«"'(]+|[»"'.,!?:;)]+$/g, '');
    if (!w) return false;
    if (pnExtra().indexOf(w) >= 0) return true;
    if (isLast && PN_EXACT_LAST.indexOf(w) >= 0) return true;
    for (var i = 0; i < PN_STEMS.length; i++) {
      var stem = PN_STEMS[i];
      if (w.indexOf(stem) === 0 && PN_TAILS.indexOf(w.slice(stem.length)) >= 0) return true;
    }
    for (var j = 0; j < PN_SURNAME.length; j++) {
      var tail = PN_SURNAME[j];
      if (w.length > tail.length + 2 && w.slice(-tail.length) === tail) return true;
    }
    return false;
  }

  /* Власні назви — з великої, решта — з малої, перше слово фрази — з великої.
     Абревіатури («ТЦК», «ДТП») лишаються великими: або зі списку, або коли
     в оголошенні вони вже великими, а сам ключ набраний не капсом. */
  function properCase(text) {
    var raw = String(text);
    var allCaps = raw === raw.toUpperCase();
    var tokens = raw.split(/(\s+)/);
    var idxs = [];
    for (var i = 0; i < tokens.length; i++) if (tokens[i].trim()) idxs.push(i);

    var proper = {};
    for (var k = 0; k + 1 < idxs.length; k++) {
      var pair = pnNorm(tokens[idxs[k]]) + ' ' + pnNorm(tokens[idxs[k + 1]]);
      if (PN_PHRASES.indexOf(pair) >= 0) {
        proper[idxs[k]] = true; proper[idxs[k + 1]] = true;
      }
    }
    for (var n = 0; n < idxs.length; n++) {
      if (pnIsProper(tokens[idxs[n]], n === idxs.length - 1)) proper[idxs[n]] = true;
    }

    var first = idxs.length ? idxs[0] : -1;
    return tokens.map(function (t, idx) {
      if (!t.trim()) return t;
      var lower = t.toLowerCase();
      if (PN_ABBR.indexOf(pnNorm(t)) >= 0) return t.toUpperCase();
      if (!allCaps && t.length <= 6 && t === t.toUpperCase() && /[А-ЯІЇЄҐA-Z]/.test(t)) return t;
      if (proper[idx]) return lower.split('-').map(pnUpFirst).join('-');
      if (idx === first) return pnUpFirst(lower);
      return lower;
    }).join('');
  }

  var utm = readUtm();
  var keyword = properCase(cleanKeyword(utm[CFG.keywordParam]));

  /* 'keyword' — завжди варіант 1, 'question' — завжди варіант 2,
     'auto' — залежно від того, чи прийшов ключовий запит. */
  var mode = CFG.mode === 'keyword' ? 'keyword'
           : CFG.mode === 'question' ? 'question'
           : (keyword ? 'keyword' : 'question');
  /* Авто-режим без ключового слова падає у варіант 2. Але якщо варіант 1
     заданий у конфізі жорстко (окрема сторінка), він лишається варіантом 1:
     без ключа просто показуємо заголовок за замовчуванням. */
  if (mode === 'keyword' && !keyword && CFG.mode !== 'keyword') mode = 'question';

  /* ============================================================
     2. Заголовок
     ============================================================ */
  (function applyTitle() {
    var kw = document.querySelector('.js-h1-keyword');
    var def = document.querySelector('.js-h1-default');
    if (!kw || !def) return;
    if (mode === 'keyword' && keyword) {
      kw.textContent = keyword;      // textContent, не innerHTML
      kw.hidden = false;
      def.hidden = true;
      document.title = keyword + ' — Консультант';
      var md = document.querySelector('meta[property="og:title"]');
      if (md) md.setAttribute('content', keyword);
    }
    document.body.setAttribute('data-lead-mode', mode);
  })();

  /* ============================================================
     3. Телефон гарячої лінії з конфігу
     ============================================================ */
  (function applyPhone() {
    var digits = String(CFG.phone || '').replace(/[^\d+]/g, '');
    if (!digits) return;
    var pretty = digits;
    var m = digits.match(/^\+380(\d{2})(\d{3})(\d{2})(\d{2})$/);
    if (m) pretty = '+380 ' + m[1] + ' ' + m[2] + ' ' + m[3] + ' ' + m[4];
    document.querySelectorAll('.js-phone-link').forEach(function (a) { a.href = 'tel:' + digits; });
    document.querySelectorAll('.js-phone-text').forEach(function (el) { el.textContent = pretty; });
  })();

  /* ============================================================
     4. Форми: поле питання, приховані поля, чіп напрямку
     ============================================================ */
  var forms = [].slice.call(document.querySelectorAll('.js-lead-form'));

  /* Напрямок, обраний карткою (перекриває utm_term для цього ліда) */
  var pickedDirection = '';

  function setHidden(form, name, value) {
    var el = form.querySelector('[name="' + name + '"]');
    if (el) el.value = value == null ? '' : value;
  }

  function directionOf(form) {
    if (pickedDirection) return { value: pickedDirection, source: 'service' };
    if (mode === 'keyword') return { value: keyword, source: 'utm_term' };
    var q = form.querySelector('.js-question');
    return { value: q ? q.value.trim() : '', source: 'question' };
  }

  forms.forEach(function (form) {
    /* приховані поля — щоб лід (і звичайний POST, і JSON) ніс усе одразу */
    UTM_KEYS.forEach(function (k) { setHidden(form, k, utm[k] || ''); });
    setHidden(form, 'referer', document.referrer || location.href);
    setHidden(form, 'partner', CFG.partner);

    /* поле «Ваше питання» — тільки у варіанті 2 */
    var qField = form.querySelector('.js-question-field');
    if (qField) qField.hidden = (mode !== 'question');

    /* чіп із обраним напрямком — з’являється після кліку по картці */
    var chip = document.createElement('div');
    chip.className = 'lf-dir';
    chip.hidden = true;
    chip.innerHTML = '<span class="lf-dir__label">Напрямок:</span> <b class="lf-dir__val"></b>' +
                     '<button type="button" class="lf-dir__x" aria-label="Прибрати напрямок">×</button>';
    form.insertBefore(chip, form.querySelector('.lf-row'));
    chip.querySelector('.lf-dir__x').addEventListener('click', function () {
      pickedDirection = '';
      syncDirectionChips();
      syncQuestionPrefix();
      document.querySelectorAll('.pcard.is-picked').forEach(function (c) { c.classList.remove('is-picked'); });
    });
  });

  function syncDirectionChips() {
    forms.forEach(function (form) {
      var chip = form.querySelector('.lf-dir');
      if (!chip) return;
      chip.hidden = !pickedDirection;
      var val = chip.querySelector('.lf-dir__val');
      if (val) val.textContent = pickedDirection;
    });
  }

  /* Підставляє «Напрямок: » у поле питання й тримає його синхронним із чіпом.
     Автопідстановку помічаємо в data-atrибуті: доки текст починається з неї,
     її можна замінити на новий напрямок або прибрати. Те, що дописав
     користувач, лишається; якщо він переписав сам префікс — не чіпаємо нічого. */
  function syncQuestionPrefix() {
    var prefix = pickedDirection ? pickedDirection + ': ' : '';
    document.querySelectorAll('.js-question').forEach(function (q) {
      var auto = q.getAttribute('data-auto-prefix') || '';
      var rest;
      if (auto && q.value.indexOf(auto) === 0) rest = q.value.slice(auto.length);
      else if (q.value.trim()) return;
      else rest = '';
      q.value = prefix + rest;
      if (prefix) q.setAttribute('data-auto-prefix', prefix);
      else q.removeAttribute('data-auto-prefix');
    });
  }

  /* ============================================================
     6. Телефон: маска + вибір коду країни
     ============================================================ */
  function groupsOf(input) {
    var g = (input.getAttribute('data-groups') || '').trim();
    return g ? g.split(',').map(Number) : [];
  }
  function maxDigits(input) { return parseInt(input.getAttribute('data-max'), 10) || 15; }

  function formatDigits(digits, groups) {
    if (!groups.length) return digits;
    var out = [], i = 0;
    for (var k = 0; k < groups.length && i < digits.length; k++) {
      out.push(digits.slice(i, i + groups[k]));
      i += groups[k];
    }
    if (i < digits.length) out.push(digits.slice(i));
    return out.filter(Boolean).join(' ');
  }
  function placeholderFor(groups) {
    if (!groups.length) return '________';
    return groups.map(function (n) { return new Array(n + 1).join('_'); }).join(' ') + ' *';
  }
  /* Люди часто вводять номер із ведучим нулем (0 50 …) — для кодів,
     де національний номер без нуля, прибираємо його автоматично. */
  function stripTrunkZero(digits, form) {
    var ccEl = form && form.querySelector('.js-lf-cc-code');
    var cc = ccEl ? ccEl.textContent.trim() : '';
    if ((cc === '+380' || cc === '+48') && digits.charAt(0) === '0') return digits.replace(/^0+/, '');
    return digits;
  }

  document.querySelectorAll('.js-lf-phone').forEach(function (input) {
    input.addEventListener('input', function () {
      var digits = (input.value.match(/\d/g) || []).join('');
      digits = stripTrunkZero(digits, input.form).slice(0, maxDigits(input));
      input.value = formatDigits(digits, groupsOf(input));
      input.classList.remove('is-bad');
      clearErr(input.form, 'phone');
    });
    input.addEventListener('keypress', function (e) {
      if (e.key && e.key.length === 1 && !/\d/.test(e.key)) e.preventDefault();
    });
  });

  document.querySelectorAll('.js-lf-cc').forEach(function (cc) {
    var btn = cc.querySelector('.js-lf-cc-btn');
    var list = cc.querySelector('.js-lf-cc-list');
    var flag = cc.querySelector('.js-lf-cc-flag');
    var code = cc.querySelector('.js-lf-cc-code');
    var input = cc.closest('.lf-phone').querySelector('.js-lf-phone');
    var form = cc.closest('form');

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = list.hidden;
      document.querySelectorAll('.js-lf-cc-list').forEach(function (l) { l.hidden = true; });
      list.hidden = !willOpen;
      btn.setAttribute('aria-expanded', String(willOpen));
    });

    list.querySelectorAll('.lf-cc-opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        code.textContent = opt.getAttribute('data-code');
        flag.src = opt.getAttribute('data-flag');
        input.setAttribute('data-max', opt.getAttribute('data-max'));
        input.setAttribute('data-groups', opt.getAttribute('data-groups'));
        setHidden(form, 'country_code', opt.getAttribute('data-country') || '');
        var digits = (input.value.match(/\d/g) || []).join('').slice(0, maxDigits(input));
        input.value = formatDigits(digits, groupsOf(input));
        input.placeholder = placeholderFor(groupsOf(input));
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        input.focus();
      });
    });
  });
  document.addEventListener('click', function () {
    document.querySelectorAll('.js-lf-cc-list').forEach(function (l) { l.hidden = true; });
  });

  /* ============================================================
     7. Валідація та відправлення
     ============================================================ */
  function setErr(form, field, msg) {
    if (!form) return;
    var input = form.querySelector('[name="' + field + '"]');
    var err = form.querySelector('.lf-err[data-for="' + field + '"]');
    if (input) input.classList.toggle('is-bad', !!msg);
    if (err) { err.textContent = msg || ''; err.classList.toggle('is-on', !!msg); }
  }
  function clearErr(form, field) { setErr(form, field, ''); }

  function submitLead(lead) {
    console.info('[lead]', lead);
    try {
      var arr = JSON.parse(localStorage.getItem('clm_lawyers_leads') || '[]');
      arr.push(lead);
      localStorage.setItem('clm_lawyers_leads', JSON.stringify(arr.slice(-50)));
    } catch (e) {}
    if (CFG.endpoint) {
      try {
        fetch(CFG.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(lead),
          keepalive: true   /* survives the redirect to the thanks page */
        }).catch(function () {});
      } catch (e) {}
    }
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'generate_lead', lead_source: lead.source, lead_direction: lead.direction });
    }
  }

  /* ============================================================
     7a. reCAPTCHA v3 (опційно).
     window.MAKSIM_RECAPTCHA друкується з functions.php тільки коли
     в темі задано ADVOKAT_RECAPTCHA_SITE_KEY і ADVOKAT_RECAPTCHA_SECRET_KEY
     (порожні значення = локалка, перевірку повністю вимкнено).
     Токен звіряється на бекенді через admin-ajax (maksim_verify_recaptcha),
     секретний ключ ніколи не потрапляє у браузер.
     ============================================================ */
  var RECAPTCHA = window.MAKSIM_RECAPTCHA || { enabled: false };

  function withRecaptcha(done) {
    if (!RECAPTCHA.enabled || !window.grecaptcha || !RECAPTCHA.siteKey) {
      done('');
      return;
    }
    grecaptcha.ready(function () {
      grecaptcha.execute(RECAPTCHA.siteKey, { action: 'lead_submit' }).then(function (token) {
        fetch(RECAPTCHA.ajaxUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'action=maksim_verify_recaptcha&nonce=' + encodeURIComponent(RECAPTCHA.nonce) +
                '&token=' + encodeURIComponent(token)
        }).then(function (r) { return r.json(); }).then(function (res) {
          done((res && res.success) ? token : false);
        }).catch(function () { done(token); }); /* мережева помилка перевірки — не блокуємо лід */
      }, function () { done(''); });
    });
  }

  forms.forEach(function (form) {
    form.querySelectorAll('.lf-input').forEach(function (inp) {
      inp.addEventListener('input', function () { clearErr(form, inp.name); });
      inp.addEventListener('change', function () { clearErr(form, inp.name); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var nameEl = form.querySelector('[name="customer_name"]');
      var phone = form.querySelector('[name="phone"]');
      var qEl = form.querySelector('.js-question');
      var catEl = form.querySelector('.js-lead-category');
      var ccEl = form.querySelector('.js-lf-cc-code');
      var cc = ccEl ? ccEl.textContent.trim() : '+380';
      var digits = (phone.value.match(/\d/g) || []).join('');
      var need = maxDigits(phone);
      var ok = true;

      /* Ім’я — необов’язкове поле (за ТЗ може бути відсутнім) */

      if (!digits.length) {
        setErr(form, 'phone', 'Вкажіть номер телефону'); ok = false;
      } else if (cc === '+' ? digits.length < 7 : digits.length !== need) {
        setErr(form, 'phone', 'Номер має містити ' + (cc === '+' ? 'щонайменше 7' : need) + ' цифр'); ok = false;
      } else clearErr(form, 'phone');

      /* У варіанті 2 напрямок беремо з питання — воно обов’язкове,
         якщо напрямок не обрано карткою */
      if (mode === 'question' && qEl && !pickedDirection) {
        var qv = qEl.value.trim();
        if (qv.length < 5) {
          setErr(form, 'question', 'Опишіть питання хоча б кількома словами'); ok = false;
        } else clearErr(form, 'question');
      }

      if (catEl) {
        if (!catEl.value) {
          setErr(form, 'lead_category', 'Оберіть напрямок'); ok = false;
        } else clearErr(form, 'lead_category');
      }

      if (!ok) {
        var bad = form.querySelector('.lf-input.is-bad');
        if (bad) bad.focus();
        return;
      }

      var dir = directionOf(form);
      setHidden(form, 'direction', dir.value);
      setHidden(form, 'direction_source', dir.source);

      /* Режим звичайного POST: усі дані вже лежать у прихованих полях,
         віддаємо форму бекенду і виходимо. */
      if (CFG.nativeSubmit && form.getAttribute('action')) {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'generate_lead',
            lead_source: form.getAttribute('data-source') || form.id,
            lead_direction: dir.value
          });
        }
        form.submit();
        return;
      }

      /* Reference for the post-submit qualification quiz: the same id
         goes into the lead and into sessionStorage, so the thanks page
         can attach its answers to THIS lead (no new lead is created). */
      var leadRef = 'L-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
      try { sessionStorage.setItem('clm_lawyers_lead_ref', leadRef); } catch (err) {}

      withRecaptcha(function (tokenOrFalse) {
        if (tokenOrFalse === false) {
          setErr(form, 'phone', 'Не вдалося підтвердити, що ви не робот. Спробуйте ще раз.');
          return;
        }

        submitLead({
          lead_ref: leadRef,
          source: form.getAttribute('data-source') || form.id,
          partner: CFG.partner,
          /* Ім’я — необов’язкове, може прийти порожнім */
          customer_name: nameEl ? nameEl.value.trim() : '',
          phone: cc + ' ' + phone.value.trim(),
          country_code: (form.querySelector('[name="country_code"]') || {}).value || '',
          /* Напрямок питання: ключовий запит, картка або текст питання */
          direction: dir.value,
          direction_source: dir.source,
          question: qEl ? qEl.value.trim() : '',
          lead_category: catEl ? catEl.value : '',
          keyword: keyword,
          utm: utm,
          referer: document.referrer || '',
          page: location.href,
          ts: new Date().toISOString(),
          /* Токен reCAPTCHA v3 — порожній, якщо капча вимкнена (немає ключів) */
          recaptcha_token: tokenOrFalse || ''
        });

        /* Per the qualification brief the thank-you is a separate page
           with 4 follow-up questions — not an inline message. */
        location.href = CFG.thanksUrl || 'thanks.html';
      });
    });
  });

  /* ============================================================
     8. Дрібна поведінка сторінки
     ============================================================ */
  function scrollToEl(target, after) {
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - 74;
    window.scrollTo({ top: top, behavior: 'smooth' });
    if (after) setTimeout(after, 600);
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      scrollToEl(target, id === '#lead' ? function () {
        var f = document.querySelector('#mainLeadForm [name="customer_name"]');
        if (f && window.matchMedia('(min-width: 700px)').matches) f.focus({ preventScroll: true });
      } : null);
    });
  });

  /* мобільна CTA-панель: показуємо, коли hero-форма пішла з екрана */
  var mcta = document.getElementById('mobileCta');
  var heroForm = document.getElementById('heroLeadForm');
  var leadSection = document.getElementById('lead');
  if (mcta && heroForm && 'IntersectionObserver' in window) {
    var heroVisible = true, leadVisible = false;
    var sync = function () { mcta.classList.toggle('is-on', !heroVisible && !leadVisible); };
    new IntersectionObserver(function (en) { heroVisible = en[0].isIntersecting; sync(); },
      { threshold: 0.15 }).observe(heroForm);
    if (leadSection) {
      new IntersectionObserver(function (en) { leadVisible = en[0].isIntersecting; sync(); },
        { threshold: 0.2 }).observe(leadSection);
    }
  }

  /* реальна висота хедера у CSS-змінну */
  var header = document.querySelector('header.site');
  function setHdr() {
    if (header) document.documentElement.style.setProperty('--hdr-h', header.offsetHeight + 'px');
  }
  setHdr();
  window.addEventListener('resize', setHdr);
  window.addEventListener('load', setHdr);

  /* ============================================================
     9. Демо-перемикач варіантів.
        За замовчуванням вимкнений: варіанти рознесені по окремих
        сторінках (index1.html / index2.html). Вмикається лише
        LEAD_CONFIG.demoSwitch = true і ніколи не рендериться, коли
        сторінку віддає бекенд (він оголошує window.PARTNER_CONTEXT).
     ============================================================ */
  if (CFG.demoSwitch === true && !window.PARTNER_CONTEXT) {
    var demo = document.createElement('div');
    demo.className = 'demo-switch';
    demo.innerHTML =
      '<span>Демо ТЗ:</span>' +
      '<button type="button" data-v="1"' + (mode === 'keyword' ? ' class="on"' : '') + '>Варіант 1 — utm_term</button>' +
      '<button type="button" data-v="2"' + (mode === 'question' ? ' class="on"' : '') + '>Варіант 2 — питання</button>';
    demo.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      try { localStorage.removeItem(STORE_KEY); } catch (err) {}
      var base = location.pathname;
      location.href = b.getAttribute('data-v') === '1'
        ? base + '?utm_source=max_ppc_gads_site&utm_medium=cpc&utm_term=' +
          encodeURIComponent('військовий адвокат бориспіль') + '&utm_content=search'
        : base;
    });
    document.body.appendChild(demo);
  }
})();